import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { H4 } from 'foundations-components/transitional/components/H4';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function IssuesViewEmptyState() {
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    justifyContent: "center",
    blockSize: "400px",
    children: [/*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(H4, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "email-management.emptyState.issuesView.title"
        })
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "email-management.emptyState.issuesView.body"
      })]
    }), /*#__PURE__*/_jsx(Illustration, {
      name: "email-empty-state-high-performing",
      marginInlineStart: "1700"
    })]
  });
}